import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "destroyUserModal",
  ]

  showDestroyUserModal(event) {
    event.preventDefault()
    $(this.destroyUserModalTarget).modal("show")
  }
}
